import script from "./analysis.vue?vue&type=script&setup=true&lang=js"
export * from "./analysis.vue?vue&type=script&setup=true&lang=js"

import "./analysis.vue?vue&type=style&index=0&id=019fcdd2&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019fcdd2"]])

export default __exports__